import moment from 'moment';
import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../reducers';
import './OrderExpandedTile.scss';
import { Accordion, AccordionSummary, AccordionDetails, Typography, Stepper, Step, StepLabel, Button, Chip, StepIconProps, StepConnector, withStyles, AccordionProps, Theme, createStyles } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LaunchIcon from '@material-ui/icons/Launch';
import InfoIcon from '@material-ui/icons/Info';

import { getOrderDetailByShopperId } from '../../chatservice/chatserverApis';
import { getShippingType,getShippingStatus } from './VerifiedOrderUtils';
import { DialogflowQueryType, MessageTypes, Speaker } from '../../models/enum';
import { dialogflowEvent, orderTrackingStatusMapping, vote } from '../../../config/config';
import { updateAnalyticsStatus } from '../../chatservice/dialogflowQuery';
import { setOrderForTile, setShowOrderTrackingDetail } from '../../../actions';
import { Check } from '@material-ui/icons';
import { makeStyles, styled } from '@material-ui/styles';
import CloseIcon from '@material-ui/icons/Close';
import SkeletonScreenOrderTracking from '../../SkeletonScreens/SkeletonScreenOrderTracking';
import { getDeliveryTime } from '../../util/dateTimeHelper';
import { isDeliveryDateToday } from '../../util/commonUtil';


type OrderExpandedTileProps = {
    order: any,
    quickReplyHandler: any,
    backToWidget: any,
    sessionId: any,
    userId: any,
    setMessages: any,
    msgs: any,
    featureDelGuarranteeMicroCopy:any
}

type DateStatus = {
    statusName: string;
    statusDateTime: string;
}
  

const OrderExpandedTile = ({order, quickReplyHandler, backToWidget, sessionId, userId, setMessages, msgs, featureDelGuarranteeMicroCopy}: OrderExpandedTileProps) => {
    const shopperId = useSelector((state: RootState) => { return state.botData.shopperId }); 
    const widgetSessionId = useSelector((state: RootState) => { return state.botData.widgetSessionId }); 

    const tileStartRef: any = useRef(null);
    const [isDataLoaded, setIsDataLoaded] = React.useState(false);
    const [lastDeliveryDate, setLastDeliveryDate] = React.useState<Date>(new Date());
    const [lastDeliveryDateTime, setLastDeliveryDateTime] = React.useState<Date>(new Date());
    const [deliveryStartTime, setDeliveryStartTime] = React.useState<string>('');
    const [deliveryEndTime, setDeliveryEndTime] = React.useState<string>('');

    const [deliveryType, setDeliveryType] = React.useState<string>('');
    const [isDeliveryToday, setIsDeliveryToday] = React.useState(false);
    const [orderData, setOrderData] = React.useState<any>(null);
    const [deliveryStatusIcon, setDeliveryStatusIcon] = React.useState<any>('');
    const [deliveryStatus, setDeliveryStatus] = React.useState<any>('');
    const [showAllProduct , setShowAllProduct] = React.useState<boolean>(false);
    const dispatch = useDispatch();
    const steps = ['Confirmed', 'Packed', 'On its way', 'Delivered'];
    const stepsFailedDelivery = ['Confirmed', 'Packed', 'On its way', 'DeliveryFailed'];
    const [showProduct, setShowProduct] = React.useState<any>()

    const [isFailed, setIsFailed] = React.useState(false);

    const [expanded, setExpanded] = React.useState<string | false>(false);

    const [deliveryMap, setDeliveryMap] = React.useState(new Map());

    let allProducts=2;

    const handleChange = (panel: string) => (event: React.ChangeEvent<{}>, newExpanded: boolean) => {
        setExpanded(newExpanded ? panel : false);
    };

    const showProducts = () => {
        setShowAllProduct(!showAllProduct)
        if (!showAllProduct) {
            setShowProduct(orderData?.products)
            allProducts = orderData?.products.length;

        }else {
            allProducts = 3;
            setShowProduct(orderData?.products.slice(0,3))
        }
    }

    const processAcceptance = (e: any, isSuccessful: boolean) => {
        updateAnalyticsStatus(sessionId, userId, order.intentGroupId, isSuccessful);
        
        const intentGroupInfo = {
            intentGroupId: order.intentGroupId,
            intentGroupName: order.intentGroupName
        }

        let eventName = (isSuccessful) ? dialogflowEvent.ORDER_TRACKING_EXPANDEDTILE_YES : dialogflowEvent.ORDER_TRACKING_EXPANDEDTILE_NO;
        let disPlayClickAsText = true;
        let renewIntentGroup = false;

        quickReplyHandler(e, DialogflowQueryType.Event, eventName, disPlayClickAsText, null, renewIntentGroup, intentGroupInfo);

        backToWidget(true);
    }

    const scrollToStart = () => {
        tileStartRef?.current?.scrollIntoView({ behavior: "smooth" });
    }; 

    const formatDateTimeStamp = (dateString: string) => {
        if (!dateString) return '';
        const date = moment(dateString);
        return {
            day: date.format('D MMM'),
            time: date.format('h:mm A')
        };
    };

    const getOrderStatusDateTime = (orderType:string, orderData:any) => {
        const statusDateTime = orderData?.statusDateList.find((item:DateStatus) => item?.statusName?.toLowerCase() === orderType?.toLowerCase())?.statusDateTime;
        return statusDateTime;
    }


    useEffect(() => {
        scrollToStart();
        // fetch article data
        if (isDataLoaded === false) {
            getOrderDetailByShopperId(shopperId, widgetSessionId, order.orderId, sessionId, userId)
                .then((result:any) => {
                    if (result.statusCode && result.statusCode !== 200) {
                        dispatch(setShowOrderTrackingDetail(false)); 
                        dispatch(setOrderForTile(null));

                        setMessages((messages: any) => [...messages, ...[{ text: `We can no longer show you these delivery details.`, from: Speaker.BWS, type: MessageTypes.Message }]]);
                        setMessages((messages: any) => [...messages, ...[{ text: `To do this, you need to log in to the account associated with the orders.`, from: Speaker.BWS, type: MessageTypes.Message }]]);
                        
                        if (shopperId === 0) {
                            setMessages((messages: any) => [...messages, ...[{ text: null, from: Speaker.BWS, type: MessageTypes.QuickReplyPayload, data: [{
                                intentGroupId : order.intentGroupId,
                                intentGroupName : order.intentGroupName,
                                target : "route",
                                text : "Login",
                                type : "url",
                                uri : "https://bws.com.au/secure-login"
                            }] }]]);
                        }
                    } else {
                        setIsDataLoaded(true);
                        setOrderData(result.data);

                        let sortedDates = result?.data?.deliveryBookingList?.sort(
                            (a:any, b:any) => new Date(b.deliveryAtDate).getTime() - new Date(a.deliveryAtDate).getTime()
                        );
                        // get the latest date
                        setLastDeliveryDate(sortedDates[0].deliveryAtDate);
                        
                        const deliveryTime = getDeliveryTime(result?.data?.deliveryBookingList[0]?.deliveryAtTime);
                        setDeliveryStartTime(deliveryTime[0])
                        setDeliveryEndTime(deliveryTime[1]);

                         let  { deliveryStatus, shippingIconUrl } = getShippingStatus(result?.data?.status);
                         setDeliveryStatusIcon(shippingIconUrl);
                         setDeliveryStatus(deliveryStatus);
                         setShowProduct(result?.data?.products?.slice(0,3))
                         setIsDeliveryToday(isDeliveryDateToday(result?.data?.deliveryDate));
                         
                         
                         if (result.data.status === "DeliveryFailed" || result.data.status === "Failed") {
                             setIsFailed(true)
                        }
                    }
                });
            }
        }, [allProducts]);
        
        useEffect(() => {
            if (!orderData || ['cancelled'].includes(orderData.status?.toLowerCase())) {
                return;
            }
            const map = new Map();
            steps.forEach(step => {
                switch (step) {
                    case 'Confirmed':
                        const orderConfirmedDate = getOrderStatusDateTime('Order Created', orderData);
                        map.set(step, formatDateTimeStamp(orderConfirmedDate));
                        break;
                        case 'Packed':
                            let orderPackedDate;
                            orderPackedDate = getOrderStatusDateTime('Order Packed', orderData);
                            if(!orderPackedDate) {
                                orderPackedDate = getOrderStatusDateTime('Delivery Requested', orderData);
                            }
                            map.set(step, formatDateTimeStamp(orderPackedDate));
                            break;
                            case 'On its way':
                                const orderOnItsWayDate = getOrderStatusDateTime('Driver Collected', orderData);
                                map.set(step, formatDateTimeStamp(orderOnItsWayDate));
                                break;
                                case 'Delivered':
                                    const orderDeliveredDate = getOrderStatusDateTime('Delivered', orderData);
                    map.set(step, formatDateTimeStamp(orderDeliveredDate));
                    break;
                    default:
                  break;
                }
            });

            if(isFailed) {
                map.set('DeliveryFailed', '');
            }

            setDeliveryMap(map);
        }, [orderData]);
        

        if (orderData?.deliveryBookingList.length > 1) {
            orderData?.deliveryBookingList.sort(
                (a:any, b:any) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
                );
            }
            
            let deliveryBooking = orderData?.deliveryBookingList[orderData?.deliveryBookingList.length - 1];
            const QontoStepIconRoot = styled("div")<{ ownerState: { active?: boolean } }>(
                () => ({
                    display: "flex",
                    height: 22,
                    alignItems: "center",
                    
                    "& .QontoStepIcon-completedIcon": {
                        color: "white",
                        zIndex: 1,
                        fontSize: 18,
                    },
                    "& .QontoStepIcon-circle": {
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    },
          "& .QontoStepIcon": {
            width: 24,
            height: 24,
            borderRadius: "50%",
            backgroundColor: "#D1D2D1",
            display:"flex",
            justifyContent: "center",
            alignItems: "center",
            
        },
          "& .QontoStepIcon-error": {
              width: 24,
              height: 24,
              borderRadius: "50%",
              backgroundColor: "#8C0728",
              display:"flex",
              justifyContent: "center",
              alignItems: "center",
              
            },
        })
        );
        
        
        function QontoStepIcon(props: StepIconProps) {
            const { active, completed, className } = props;
            
            return (
                <QontoStepIconRoot className={className}>

            {!active ? (
                completed ? (
                    <div className="QontoStepIcon-circle">
                  <Check className="QontoStepIcon-completedIcon" />
                </div>):
                (<div className="QontoStepIcon" >
                    <Check className="QontoStepIcon-completedIcon" />
                </div>)
              ) : isFailed?(<div>
                <div className="QontoStepIcon-error" >

                <CloseIcon className="QontoStepIcon-completedIcon"/>
                </div>
            </div>):
              (  <div className="QontoStepIcon-circle">
              <Check className="QontoStepIcon-completedIcon" />
            </div>

            )}
          </QontoStepIconRoot>
        );
    }
    const Connector = withStyles({
        alternativeLabel: { top: 9 },
        
        active:{'& $line': { borderColor: '#00B5A9' } },
        completed: { '& $line': { borderColor: '#00B5A9' } },          
        line: {
            borderTopWidth: 2,
        },
        vertical: {
            marginLeft: 9,
        },        
        
    })(StepConnector);  
    const ConnectorFailed = withStyles({
        alternativeLabel: { top: 9 },
        
        active:{'& $line': { borderColor: '#8C0728' } },
        completed: { '& $line': { borderColor: '#00B5A9' } },          
        line: {
            borderTopWidth: 2,
        },
        vertical: {
          marginLeft: 9,
        },        
        
    })(StepConnector);  
    
    return (
        <div className={isDataLoaded ? 'scroller' : 'skeleton-screen'}>
            {
                isDataLoaded === true && 
                <div className='expandedTiles' ref={ tileStartRef } >
                    <div className='expandedTiles-summary'>
                    <div className='expandedTiles-deliveryType'>
                            <img src={deliveryStatusIcon}  alt="icon" />
                            <div className='expandedTiles-deliveryType-status'>    
                                <span>{ deliveryStatus ?? orderData?.status }</span>
                            </div>
                        </div>                        
                        <span className='expandedTiles-orderNumber'>Confirmed { moment(orderData?.date).format('DD MMM YYYY') } | Order #{ orderData?.orderId }</span>
                        {isDeliveryToday?
                        <div className='expandedTiles-deliveryDate'>
                            <span className="expandedTiles-deliveryDate-text">Expected delivery: </span> 
                            <span className='expandedTiles-deliveryDate-date'>{moment(deliveryStartTime, "HH:mm:ss").format("LT")} - {moment(deliveryEndTime, "HH:mm:ss").format("LT")}, today</span> 
                        </div>
                        :<div className='expandedTiles-deliveryDate'>
                            <span className="expandedTiles-deliveryDate-text">Expected delivery on: </span>
                            <span className='expandedTiles-deliveryDate-date'>{  moment(lastDeliveryDate).format('DD MMM') }, {moment(deliveryStartTime, "HH:mm:ss").format("LT")} - {moment(deliveryEndTime, "HH:mm:ss").format("LT")}</span>
                        </div>
                        }
                    </div>

                    {featureDelGuarranteeMicroCopy.current && orderData?.deliveryType==="ASAP" && steps.indexOf(orderData?.status)>0 && orderData?.status!=='Delivered' && 
                        <div className="expandedTiles-deliveryGuarantee">
                            <span>If we’re more than 1hr, your next delivery will be on us. T&Cs</span>
                        </div>
                    }

                    {orderData?.status==="Cancelled" && 
                        <div className="expandedTiles-deliveryCancelled">
                            <span>
                                Didn’t cancel? It may be that we’re having trouble finding you a driver right now. You should receive a text message for the next step.
                            </span>
                        </div>
                    }

                    { (orderData?.status==="Failed" || orderData?.status==="DeliveryFailed") &&
                        <div className="expandedTiles-deliveryFailed">
                            <span>Sorry it looks like the driver attempted the delivery but was unsuccessful.</span>
                        </div>
                    }

                    <Accordion className='accordionCustomStyle' expanded={ true }>

                        <AccordionDetails className='accordionCustomStyle-details'>
                            <Typography>
                                {orderData?.status!=="Cancelled"?
                                <div className='accordionCustomStyle-stepper'>
                                        {isFailed?  
                                       <Stepper activeStep={stepsFailedDelivery.indexOf(orderTrackingStatusMapping[orderData?.status] || orderData?.status)} alternativeLabel 
                                       connector={
                                       <ConnectorFailed/>
                                       }>
                                          { stepsFailedDelivery.map((label) => (
                                               <Step key={label}>
                                                   <StepLabel StepIconComponent={QontoStepIcon}>
                                                        <span className='delivery-label'>{label === 'DeliveryFailed' ? 'Failed' : label}</span>
                                                        {deliveryMap.has(label) && <span className='delivery-timestamp'>{deliveryMap.get(label)?.day}</span>}
                                                        {deliveryMap.has(label) && <span className='delivery-timestamp'>{deliveryMap.get(label)?.time}</span>}
                                                   </StepLabel>
                                            </Step>
                                        ))}
                                        </Stepper>:
                                    <Stepper activeStep={ steps.indexOf(orderTrackingStatusMapping[orderData?.status] || orderData?.status)} alternativeLabel connector={<Connector/>}>

                                      {  steps.map((label) => (
                                            <Step key={label}>
                                                <StepLabel StepIconComponent={QontoStepIcon}>
                                                    <span className='delivery-label'>{label}</span>
                                                    {deliveryMap.has(label) && <span className='delivery-timestamp'>{deliveryMap.get(label)?.day}</span>}
                                                    {deliveryMap.has(label) && <span className='delivery-timestamp'>{deliveryMap.get(label)?.time}</span>}
                                                </StepLabel>
                                            </Step>
                                        ))}
                                    </Stepper>}
                                </div>:''    
                                }
                                
                                <div className='expandedTiles__orderDetails'>
                                    {showProduct?.map((product:any, index:number)=>{
                                        return(
                                            <>
                                            
                                                <div className='expandedTiles__orderDetails-info'>
                                                    <div className="expandedTiles__orderDetails-images">
                                                        <img src={order.productImages[index]} alt="" />
                                                    </div>
                                                    <div className="expandedTiles__orderDetails-label">
                                                        <span className='expandedTiles__orderDetails-label-name'>{product.name}</span>
                                                        <span className='expandedTiles__orderDetails-label-quantity'>{product.quantity} {product.quantity===1?'Unit':'Units'}</span>
                                                    </div>
                                                </div>
                                            </>
                                            )
                                            
                                        })
                                    }
                                    {orderData?.products.length>3 &&
                                    (
                                    <div className='expandedTiles__all-products'>
                                        {!showAllProduct?
                                        <div className='expandedTiles__all-products-showMore'>
                                            <span onClick={showProducts}>Show More</span>
                                            <img src="/images/Vector-downArrow.svg" alt="" />
                                        </div>
                                        :<div className='expandedTiles__all-products-showLess'>
                                            <span onClick={showProducts}>Show less</span>
                                            <img src="/images/Vector-upArrow.svg" alt="" />
                                        </div>
                                    }
                                    </div>
                                    )
                                    }
                                </div>

                                { orderData?.status!=='Cancelled'?         
                                    <div className='accordionCustomStyle-trackingBtn'>
                                    {
                                        deliveryBooking?.deliveryUpdate?.trackingUrl &&
                                        orderData?.status !== 'DeliveryFailed' && 
                                        orderData?.status !== 'Cancelled' && 
                                        orderData?.status !== 'DeliveryCancelled' && 
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            endIcon={<LaunchIcon>LaunchIcon</LaunchIcon>}
                                            href={ deliveryBooking?.deliveryUpdate?.trackingUrl }
                                            target="_blank"
                                            >
                                            Track your order
                                        </Button>
                                    }
                                    
                                    {
                                        !deliveryBooking?.deliveryUpdate?.trackingUrl &&
                                        <div className='accordionCustomStyle-info' >
                                            <img src="/images/Onitsway.svg" alt="" />
                                            <span>Tracking link will appear once the order is <strong>on its way</strong></span>
                                        </div>
                                    }
                                    </div>:""
                                }
                            </Typography>
                        </AccordionDetails>
                    </Accordion>
                    
                    <div className="vote">
                        <div className="vote__question">{vote.QUESTION_TEXT_ORDERTRACKING}</div>
                        <div className="vote__button-container">
                            <div className="vote__button" id="yes-vote-button" aria-label='smile' onClick={(event) => processAcceptance(event, true)}>{vote.YES_TEXT}</div>
                            <div className="vote__button" id="no-vote-button" aria-label='frown' onClick={(event) => processAcceptance(event, false)}>{vote.NO_TEXT}</div>
                        </div>
                    </div>
                </div>
            }

            { isDataLoaded === false && <SkeletonScreenOrderTracking/> }
        </div>
    )
}

export default OrderExpandedTile